function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#006775"
    },
    cx: 256,
    cy: 255.969,
    r: 255.969
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#055661"
    },
    d: "M511.4,272.941L383.728,145.27L128.331,419.701l89.432,89.432 c12.497,1.892,25.282,2.866,38.295,2.866c135.639,0,246.684-105.541,255.398-239.002L511.4,272.941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F7F8"
    },
    d: "M128.274,92.241H329.84l53.831,52.972v274.431H128.274V92.241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DADA"
    },
    d: "M356.384,118.785l27.289,26.428v41.907l-53.831-41.792L356.384,118.785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B3B3"
    },
    d: "M329.84,92.241l53.831,52.972l-53.831,0.115L329.84,92.241L329.84,92.241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727271"
    },
    d: "M167.428,128.129l18.402,23.161v-16.051c0-2.236-0.344-3.784-0.975-4.586 c-0.859-1.09-2.35-1.605-4.471-1.548v-0.974h12.325v0.974c-1.605,0.229-2.637,0.458-3.211,0.802 c-0.516,0.344-0.974,0.859-1.262,1.605c-0.286,0.745-0.458,2.006-0.458,3.784v31.13h-0.917l-25.225-31.13v23.849 c0,2.178,0.516,3.612,1.491,4.414c0.974,0.745,2.121,1.147,3.383,1.147h0.859v0.974h-13.3v-0.974c2.064,0,3.497-0.458,4.299-1.262 c0.802-0.859,1.204-2.236,1.204-4.242v-26.428l-0.802-0.974c-0.802-1.032-1.491-1.663-2.121-2.006s-1.491-0.516-2.637-0.516v-0.974 h13.243L167.428,128.129z M209.451,130.251v15.25h0.745c2.35,0,4.07-0.745,5.16-2.236s1.72-3.669,2.064-6.592h1.09v19.549h-1.09 c-0.229-2.121-0.688-3.898-1.376-5.217c-0.688-1.376-1.548-2.293-2.465-2.751s-2.293-0.688-4.07-0.688v10.491 c0,2.064,0.115,3.325,0.286,3.784c0.172,0.458,0.516,0.859,0.974,1.147c0.458,0.286,1.262,0.458,2.293,0.458h2.236 c3.497,0,6.306-0.802,8.37-2.408c2.121-1.605,3.612-4.07,4.529-7.338h1.032l-1.663,11.867H195.29v-0.974h1.204 c1.09,0,1.949-0.172,2.637-0.573c0.458-0.286,0.859-0.688,1.09-1.319c0.172-0.458,0.286-1.605,0.286-3.497v-24.651 c0-1.72-0.057-2.751-0.115-3.153c-0.172-0.63-0.516-1.147-1.032-1.491c-0.688-0.516-1.663-0.802-2.866-0.802h-1.204v-0.974h31.244 v11.065h-1.09c-0.516-2.694-1.262-4.643-2.236-5.79s-2.293-2.064-4.07-2.579c-1.032-0.344-2.923-0.516-5.733-0.516h-3.898 L209.451,130.251z M287.589,128.129v0.974c-0.688,0.057-1.262,0.229-1.777,0.573c-0.458,0.344-0.917,0.859-1.262,1.548 c-0.115,0.229-0.688,1.663-1.72,4.299l-11.695,30.843h-1.032l-9.23-24.307l-10.262,24.307h-0.974l-12.326-30.497 c-1.262-3.096-2.121-4.988-2.637-5.618c-0.516-0.63-1.319-1.032-2.522-1.147v-0.974h16.166v0.974 c-1.319,0.057-2.178,0.229-2.579,0.573c-0.458,0.344-0.63,0.802-0.63,1.319c0,0.688,0.458,2.178,1.376,4.471l7.338,18.116 l5.905-14.332l-1.491-3.841c-0.859-2.178-1.491-3.612-1.949-4.357c-0.458-0.745-0.974-1.262-1.605-1.548 c-0.573-0.286-1.491-0.458-2.637-0.458v-0.974h17.944v0.974c-1.262,0-2.178,0.115-2.751,0.286c-0.401,0.115-0.688,0.344-0.917,0.63 c-0.229,0.286-0.344,0.63-0.344,1.032c0,0.458,0.401,1.72,1.204,3.898l6.764,17.715l6.077-15.995c0.63-1.663,1.032-2.809,1.204-3.44 s0.229-1.147,0.229-1.663c0-0.745-0.229-1.376-0.745-1.777c-0.516-0.458-1.491-0.688-2.923-0.688v-0.974h9.689L287.589,128.129z  M314.591,127.269l0.286,12.44h-1.147c-0.516-3.096-1.835-5.618-3.898-7.51c-2.121-1.892-4.357-2.866-6.764-2.866 c-1.892,0-3.383,0.516-4.471,1.491c-1.09,0.974-1.663,2.178-1.663,3.44c0,0.802,0.172,1.548,0.573,2.178 c0.516,0.859,1.376,1.72,2.579,2.579c0.859,0.573,2.866,1.663,5.962,3.211c4.357,2.121,7.338,4.185,8.828,6.077 c1.491,1.892,2.236,4.07,2.236,6.535c0,3.096-1.204,5.79-3.669,8.026c-2.408,2.236-5.504,3.383-9.288,3.383 c-1.147,0-2.293-0.115-3.325-0.344c-1.032-0.229-2.35-0.688-3.956-1.376c-0.859-0.344-1.605-0.573-2.178-0.573 c-0.458,0-0.974,0.172-1.491,0.573c-0.516,0.401-0.974,0.917-1.319,1.72h-0.974V152.15h0.974c0.802,3.956,2.35,6.995,4.643,9.058 c2.293,2.064,4.815,3.096,7.453,3.096c2.064,0,3.726-0.573,4.93-1.663c1.204-1.09,1.835-2.408,1.835-3.898 c0-0.859-0.229-1.72-0.688-2.579c-0.458-0.802-1.147-1.605-2.121-2.35c-0.974-0.745-2.637-1.72-5.103-2.923 c-3.383-1.663-5.848-3.096-7.338-4.242c-1.491-1.147-2.637-2.465-3.44-3.956c-0.802-1.433-1.204-3.039-1.204-4.815 c0-2.981,1.09-5.504,3.268-7.625s4.93-3.153,8.255-3.153c1.204,0,2.408,0.115,3.497,0.458c0.859,0.229,1.892,0.63,3.153,1.204 c1.262,0.573,2.121,0.859,2.579,0.859c0.458,0,0.859-0.115,1.147-0.458c0.286-0.286,0.516-0.974,0.745-2.121h0.859L314.591,127.269z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 272.108,
    y: 297.71,
    style: {
      fill: "#00CC96"
    },
    width: 71.486,
    height: 89.265
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.419,
    y: 197.439,
    style: {
      fill: "#00CC96"
    },
    width: 89.485,
    height: 89.315
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E84F4F"
    },
    d: "M253.078,275.349h100.784v10.491H253.078V275.349z M253.078,197.439h100.784v10.548H253.078V197.439 z M253.078,216.93h100.784v10.491H253.078V216.93z M253.078,236.422h100.784v10.491H253.078V236.422z M253.078,255.914h100.784 v10.491H253.078V255.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E84F4F"
    },
    d: "M154.415,375.673h100.784v10.491H154.415V375.673z M154.415,297.764h100.784v10.548H154.415V297.764 z M154.415,317.256h100.784v10.491H154.415V317.256z M154.415,336.748h100.784v10.491H154.415V336.748z M154.415,356.238h100.784 v10.491H154.415V356.238z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumento);
export default __webpack_public_path__ + "static/media/documento.9482e43c3880c0dd58176c4285a7cf5e.svg";
export { ForwardRef as ReactComponent };